export const DEVICE_LIST_REQUEST = 'DEVICE_LIST_REQUEST'
export const DEVICE_LIST_SUCCESS = 'DEVICE_LIST_SUCCESS'
export const DEVICE_LIST_FAIL = 'DEVICE_LIST_FAIL'

export const DEVICE_DETAILS_REQUEST = 'DEVICE_DETAILS_REQUEST'
export const DEVICE_DETAILS_SUCCESS = 'DEVICE_DETAILS_SUCCESS'
export const DEVICE_DETAILS_FAIL = 'DEVICE_DETAILS_FAIL'

export const DEVICE_DELETE_REQUEST = 'DEVICE_DELETE_REQUEST'
export const DEVICE_DELETE_SUCCESS = 'DEVICE_DELETE_SUCCESS'
export const DEVICE_DELETE_FAIL = 'DEVICE_DELETE_FAIL'

export const DEVICE_CREATE_REQUEST = 'DEVICE_CREATE_REQUEST'
export const DEVICE_CREATE_SUCCESS = 'DEVICE_CREATE_SUCCESS'
export const DEVICE_CREATE_FAIL = 'DEVICE_CREATE_FAIL'
export const DEVICE_CREATE_RESET = 'DEVICE_CREATE_RESET'

export const DEVICE_UPDATE_REQUEST = 'DEVICE_UPDATE_REQUEST'
export const DEVICE_UPDATE_SUCCESS = 'DEVICE_UPDATE_SUCCESS'
export const DEVICE_UPDATE_FAIL = 'DEVICE_UPDATE_FAIL'
export const DEVICE_UPDATE_RESET = 'DEVICE_UPDATE_RESET'

export const DEVICE_CREATE_REVIEW_REQUEST = 'DEVICE_CREATE_REVIEW_REQUEST'
export const DEVICE_CREATE_REVIEW_SUCCESS = 'DEVICE_CREATE_REVIEW_SUCCESS'
export const DEVICE_CREATE_REVIEW_FAIL = 'DEVICE_CREATE_REVIEW_FAIL'
export const DEVICE_CREATE_REVIEW_RESET = 'DEVICE_CREATE_REVIEW_RESET'

export const DEVICE_TOP_REQUEST = 'DEVICE_TOP_REQUEST'
export const DEVICE_TOP_SUCCESS = 'DEVICE_TOP_SUCCESS'
export const DEVICE_TOP_FAIL = 'DEVICE_TOP_FAIL'
